class PdpJourny extends HTMLElement {
  constructor() {
    super();
    this.allSelectionProductInputs = this.querySelectorAll(".selection__input");
    this.allInput = this.querySelectorAll("input");
    this.allNextStepBtns = document.querySelectorAll(".next_step__btn");
    this.PDPBlocks = this.querySelectorAll(".PDP__block");
    this.addToCartBtns = document.querySelectorAll(".ADC__btn.next_step__btn");
    this.product_id = this.getAttribute("product-id");
    this.variant_id = this.getAttribute("variant-id");
    this.undoBtns = this.querySelectorAll(".progress_bar__step");
    this.productImages = document.querySelectorAll(
      ".swiper-wrapper .product__media-subitem .product__media img"
    );
    this.selectBoxPlans = this.querySelector(".select_box__plans");
    this.selectDropDown = this.querySelector("#subscriptionPlan");
    this.shellProductCard = this.querySelectorAll("label.product__shell");
    this.swiper = document.querySelector(".product__media-list");
    this.pdpBtns = this.querySelectorAll("button");
    this.stickyBtns = document.querySelectorAll("sticky-atcs button");
    this.pdpInputs = this.querySelectorAll("input");
  }

  connectedCallback() {
    this.initializeEventListeners();
    this.updateSellingPlanUsp();
  }

  initializeEventListeners() {
    this.selectDropDown.addEventListener("mousedown", (e) => {
      e.preventDefault();
      this.querySelector(".selling-plan--usps").classList.add("d-none");
      if (!this.selectDropDown.disabled) {
        this.selectDropDown.style.display = "none";
        this.selectBoxPlans.style.display = "flex";
        const plansCards = this.selectBoxPlans.closest(".plans__cards");
        if (window.innerWidth <= 1025) {
          plansCards.style.height = "90px";
        } else {
          plansCards.style.height = "100px";
        }
      }
    });
    this.selectBoxPlans.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        this.selectBoxPlans.querySelectorAll("button").forEach((btn2) => {
          btn2.classList.remove("select_btn_active__btn");
        });
        btn.classList.add("select_btn_active__btn");
        const btnValue = btn.getAttribute("plan-name");
        this.selectDropDown.querySelectorAll("option").forEach((option) => {
          if (option.getAttribute("plan-name") === btnValue) {
            // console.log(option.getAttribute('value'))
            this.selectDropDown.value = option.getAttribute("value");
          }
        });
        this.updateSellingPlanUsp();
        this.querySelector(".selling-plan--usps").classList.remove("d-none");
        this.selectBoxPlans.style.display = "none";
        this.selectDropDown.style.display = "unset";
        this.selectBoxPlans.closest(".plans__cards").style.height = "unset";
        this.updateATCPrice();
      });
    });
    this.PDPBlocks.forEach((el) => {
      el.addEventListener("click", (e) => {
        // Skip if the click is on a product shell, scent or plan that we handle separately
        if (
          e.target.closest(".product__shell") ||
          e.target.closest(".product__scent") ||
          e.target.closest(".plans__wrapper-inner label")
        ) {
          // These are handled by our custom handlers below
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        // Original behavior for other elements
        if (
          e.target.closest(".inputs__wrapper") === null &&
          e.target.closest(".plans_inputs__wrapper") === null
        ) {
          this.PDPBlocks.forEach((el2) => {
            el2.classList.remove("reopened__block");
            el2.classList.add("inactive--block");
            el2.classList.remove("semi-active--block");
            el2.classList.remove("reopened__block");
          });
          el.classList.add("reopened__block");
          el.classList.remove("inactive--block");
          el.classList.add("semi-active--block");
        } else {
          if (
            this.querySelector(
              ".scent__products:has(.selection__input:checked)"
            )
          ) {
            this.querySelector(".buying__plan").classList.remove(
              "inactive--block"
            );
            this.querySelector(".buying__plan").classList.add(
              "semi-active--block"
            );
          }
        }
      });
    });
    this.allInput.forEach((el) => {
      el.addEventListener("change", () => {
        // Skip if this is a shell, scent, or plan input that we handle separately
        if (
          el.closest(".shell__products") ||
          el.closest(".scent__products") ||
          el.name === "planChoice"
        ) {
          return;
        }

        this.updateAddToCartBtn();
        this.updateATCPrice();
        const currentBlock = el.closest(".PDP__block");
        if (
          currentBlock &&
          currentBlock.nextElementSibling &&
          currentBlock.nextElementSibling.classList.contains("PDP__block")
        ) {
          currentBlock.nextElementSibling.classList.remove("inactive--block");
          currentBlock.nextElementSibling.classList.add("semi-active--block");
          currentBlock.classList.remove("reopened__block");
        }
      });
    });
    this.addToCartBtns.forEach((btn) => {
      if (!btn.classList.contains("sticky__btn")) {
        btn.addEventListener("click", () => {
          this.addToCart();
        });
      }
    });

    // Add event listener for sticky button
    this.stickyBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.addToCart();
      });
    });
    // Shell product selection with check mark animation and delay
    this.shellProductCard.forEach((shellCard) => {
      shellCard.addEventListener("click", (e) => {
        const input = document.getElementById(shellCard.getAttribute("for"));
        const featuredImageName = input?.dataset.featuredImage;
        console.log(featuredImageName);
        const selectedImage = document.querySelector(
          `[data-featured-media*='${featuredImageName}'`
        );
        const selectedImageIndex = selectedImage?.dataset.index;
        if (selectedImageIndex !== null || selectedImageIndex !== undefined) {
          const gallery = document.querySelector(".product__media-list");
          gallery.swiper.slideTo(selectedImageIndex);
        }

        if (input) {
          // Find the check mark SVG
          const progressBarElement = input
            .closest(".PDP__block")
            .querySelector(".progress__bar svg");
          const currentBlock = input.closest(".PDP__block");
          currentBlock?.classList.remove("reopened__block");
          const nextBlock = currentBlock.nextElementSibling;

          // Mark input as checked but hide check mark
          input.checked = true;

          setTimeout(() => {
            if (progressBarElement) {
              setTimeout(() => {
                if (nextBlock && nextBlock.classList.contains("PDP__block")) {
                  nextBlock.classList.remove("inactive--block");
                  nextBlock.classList.add("semi-active--block");
                }

                // Update UI
                this.updateAddToCartBtn();
                this.updateATCPrice();
              }, 300);
            }
          }, 300);
        }
      });
    });

    // Scent product selection with check mark animation and delay
    const scentProductCards = this.querySelectorAll("label.product__scent");
    scentProductCards.forEach((scentCard) => {
      scentCard.addEventListener("click", (e) => {
        const input = document.getElementById(scentCard.getAttribute("for"));
        if (input) {
          // Find the check mark SVG
          const progressBarElement = input
            .closest(".PDP__block")
            .querySelector(".progress__bar svg");
          const currentBlock = input.closest(".PDP__block");
          currentBlock?.classList.remove("reopened__block");
          const nextBlock = currentBlock.nextElementSibling;

          // Mark input as checked but hide check mark
          input.checked = true;

          setTimeout(() => {
            if (progressBarElement) {
              setTimeout(() => {
                if (nextBlock && nextBlock.classList.contains("PDP__block")) {
                  nextBlock.classList.remove("inactive--block");
                  nextBlock.classList.add("semi-active--block");

                  // Auto-select subscription input when step 3 is reached
                  if (nextBlock.classList.contains("buying__plan")) {
                    const subscriptionInput =
                      nextBlock.querySelector("#subscribtionPlans");
                    if (subscriptionInput && !subscriptionInput.checked) {
                      subscriptionInput.checked = true;
                      this.updateAddToCartBtn();
                      this.updateATCPrice();
                    }
                  }
                }

                // Update UI
                this.updateAddToCartBtn();
                this.updateATCPrice();
              }, 300);
            }
          }, 300);
        }
      });
    });

    // Plan selection with check mark animation and delay
    const planOptions = this.querySelectorAll(
      ".subscribtion_plans_input__wrapper"
    );
    planOptions.forEach((planOption) => {
      planOption.addEventListener("click", (e) => {
        const input = planOption.querySelector("input");
        input.checked = true;

        if (input) {
          // Find the check mark SVG
          const progressBarElement = input
            .closest(".PDP__block")
            .querySelector(".progress__bar svg");

          // Mark input as checked but hide check mark if it exists
          setTimeout(() => {
            if (progressBarElement) {
              // Enable Add to Cart button if all selections are made
              this.addToCartBtns.forEach((btn) => {
                if (
                  this.querySelector(
                    ".shell__products .selection__input:checked"
                  ) &&
                  this.querySelector(
                    ".scent__products .selection__input:checked"
                  ) &&
                  this.querySelector("input[name=planChoice]:checked")
                ) {
                  btn.disabled = false;
                }
              });
            }
            // Always update the price regardless of check mark
            this.updateAddToCartBtn();
            this.updateATCPrice();
          }, 300);
        }
      });
    });
  }
  updateSellingPlanUsp() {
    const selectedSellingPlan = this.querySelector(
      "#subscriptionPlan option:checked"
    );
    const selectedSellingPlanName =
      selectedSellingPlan.getAttribute("plan-name");
    this.querySelectorAll(".selling-plan--usps .selling-plan-usp").forEach(
      (el) => {
        if (el.getAttribute("selling-plan-name") === selectedSellingPlanName) {
          el.classList.remove("d-none");
        } else {
          el.classList.add("d-none");
        }
      }
    );
  }
  updateAddToCartBtn() {
    let isCechedCounter = 0;
    this.allInput.forEach((el) => {
      if (el.checked) {
        isCechedCounter++;
      }
    });
    if (isCechedCounter === 3) {
      this.addToCartBtns.forEach((btn) => {
        if (!btn.classList.contains("sticky__btn")) {
          btn.disabled = false;
        }
      });
    }
  }
  updateStickyBtns() {
    this.pdpBtns.forEach((el) => {
      this.stickyBtns.forEach((btn) => {
        if (
          Array.from(el.classList).join(" ") ===
            Array.from(btn.classList)
              .filter((cls) => cls !== "d-none")
              .filter((cls) => cls !== "sticky__btn")
              .join(" ") &&
          el.disabled === false
        ) {
          btn.disabled = false;
        }
      });
    });
  }

  updateProductImage(productName) {
    this.productImages.forEach((el) => {
      if (el.getAttribute("alt") === productName) {
        const idx = el
          .closest(".product__media-subitem")
          .getAttribute("aria-label")
          .split("/")[0];
        this.swiper.swiper.slideTo(+idx - 1);
      }
    });
  }

  async getTheBundleID() {
    const bundle = {
      externalProductId: this.getAttribute("product-id"),
      externalVariantId: this.getAttribute("variant-id"),
      selections: [
        {
          collectionId: this.getAttribute("shell-collection-id"),
          externalProductId: this.querySelector(
            ".shell__products .selection__input:checked"
          ).getAttribute("shell-product-id"),
          externalVariantId: this.querySelector(
            ".shell__products .selection__input:checked"
          ).getAttribute("shell-variant-id"),
          quantity: 1,
        },
        {
          collectionId: this.getAttribute("scent-collection-id"),
          externalProductId: this.querySelector(
            ".scent__products .selection__input:checked"
          ).getAttribute("scent-product-id"),
          externalVariantId: this.querySelector(
            ".scent__products .selection__input:checked"
          ).getAttribute("scent-variant-id"),
          quantity: 1,
        },
      ],
    };
    // console.log(bundle);
    try {
      const rbId = await recharge.bundle.getBundleId(bundle);
      return rbId;
    } catch (error) {
      console.error("Error fetching bundle ID:", error);
      return null;
    }
  }

  async addToCart() {
    let sellingPlanId = null;
    if (
      this.querySelector("input[name=planChoice]:checked").getAttribute(
        "selling-plan"
      ) === "true"
    ) {
      const selectedPlan = this.querySelector(".selling-plan-option:checked");
      //if (selectedPlan) sellingPlanId = selectedPlan.getAttribute("data-value");
      if (selectedPlan) {
        let sellingPlanIndex = selectedPlan.value;
        const planName = selectedPlan.getAttribute("data-plan-handle");
        // Find the checked scent product input and get the selling plan ID from it
        const checkedScentInput = this.querySelector(
          ".scent__products .selection__input:checked"
        );
        if (checkedScentInput) {
          sellingPlanId = checkedScentInput.getAttribute(
            `data-selling-plan-${planName}`
          );
        }
      }
    }
    this.addToCartBtns.forEach((btn) => {
      if (!btn.classList.contains("sticky__btn")) {
        btn.querySelector(".next_step__description").innerText = "Loading...";
        btn.disabled = true;
      }
    });

    // Also update sticky buttons
    this.stickyBtns.forEach((btn) => {
      const descElement = btn.querySelector(".next_step__description");
      if (descElement) {
        descElement.innerText = "Loading...";
      }
      btn.disabled = true;
    });
    let id = "";
    await this.getTheBundleID()
      .then((bundleId) => {
        id = bundleId;
      })
      .catch((error) => {
        console.error("Error retrieving bundle ID:", error);
      });
    // console.log(id)
    const selectionPlan = this.querySelector(".selection__plan:checked");
    const selectedProducts = this.querySelectorAll(
      ".selection__input:checked+label"
    );
    const slectedProductsHandles = this.querySelectorAll(
      "input[_prodcut-handle]:checked"
    );
    let contents = [];
    selectedProducts.forEach((el) => {
      if (el.querySelector(".product_type__text"))
        contents.push(
          "1x " + el.querySelector(".product_type__text").innerText
        );
    });
    const properties = {};
    slectedProductsHandles.forEach((el, idx) => {
      properties[`_prodcut-handle${idx}`] = el.getAttribute("_prodcut-handle");
    });
    const subscriptionPlan = document.querySelector("#subscriptionPlan");
    if (selectionPlan && subscriptionPlan) {
      const selectedOption =
        subscriptionPlan.options[subscriptionPlan.selectedIndex];
      if (selectedOption && selectedOption.text) {
        // if(this.querySelector("input[name=planChoice]:checked").getAttribute("selling-plan") === "true"){
        //   properties["selling_plan"] = selectedOption.getAttribute("plan-name");
        // }
      }
    }
    const uniqueId = Date.now();

    let formData = {
      items: [
        {
          id: this.querySelector(
            ".scent__products .selection__input:checked"
          ).getAttribute("scent-variant-id"),
          quantity: 1,
          ...(sellingPlanId && { selling_plan: sellingPlanId }),
          properties: {
            ...properties,
            _unique_id: uniqueId,
          },
        },
        {
          id: this.querySelector(
            ".shell__products .selection__input:checked"
          ).getAttribute("shell-variant-id"),
          quantity: 1,
          properties: {
            _unique_id: uniqueId,
          },
        },
      ],
    };

    // Add sections parameter for cart drawer update
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      const sections = cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      formData.sections = sections;
      formData.sections_url = window.location.pathname;
    }
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        // Reset button text for regular buttons
        this.addToCartBtns.forEach((btn) => {
          if (!btn.classList.contains("sticky__btn")) {
            btn.querySelector(".next_step__description").innerText =
              "Add to cart";
            btn.disabled = false;
          }
        });

        // Reset button text for sticky buttons
        this.stickyBtns.forEach((btn) => {
          const descElement = btn.querySelector(".next_step__description");
          if (descElement) {
            // For sticky buttons, we need to preserve the price structure
            const priceSpan = descElement.querySelector(
              ".sticky-footer-button__price"
            );
            if (priceSpan) {
              descElement.innerHTML = `Add to cart - ${priceSpan.outerHTML}`;
            } else {
              descElement.innerText = "Add to cart";
            }
          }
          btn.disabled = false;
        });

        // Open cart drawer instead of redirecting to cart page
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.renderContents(parsedState);

          // Trigger cart update event to ensure upsell handler is notified
          document.dispatchEvent(
            new CustomEvent("cart-drawer-content-updated", {
              detail: { source: "pdp-add-to-cart", cart: parsedState },
            })
          );
        } else {
          // Fallback to cart page if cart drawer doesn't exist
          window.location.href = "/cart";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.addToCartBtns.forEach((btn) => {
          if (!btn.classList.contains("sticky__btn")) {
            btn.querySelector(".next_step__description").innerText =
              "Add to cart";
            btn.disabled = false;
          }
        });

        // Also reset sticky buttons
        this.stickyBtns.forEach((btn) => {
          const descElement = btn.querySelector(".next_step__description");
          if (descElement) {
            // For sticky buttons, we need to preserve the price structure
            const priceSpan = descElement.querySelector(
              ".sticky-footer-button__price"
            );
            if (priceSpan) {
              descElement.innerHTML = `Add to cart - ${priceSpan.outerHTML}`;
            } else {
              descElement.innerText = "Add to cart";
            }
          }
          btn.disabled = false;
        });
      });
  }

  updateATCPrice() {
    let finalPrice = null;
    const planSelect = this.querySelector("input[name=planChoice]:checked");
    if (planSelect) {
      finalPrice = planSelect
        .closest(".plans__wrapper-inner")
        .querySelectorAll(".price-wrapper>*");
    }
    this.addToCartBtns.forEach((btn) => {
      const desc = btn.querySelector(".next_step__description");
      if (desc) {
        if (finalPrice) {
          desc.innerText = `Add to cart – ${finalPrice[0].innerText}`;
        } else {
          desc.innerText = "Add to cart";
        }
      }
    });
  }
}

customElements.define("pdp-journy", PdpJourny);
